'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _UIBadge = require('UIComponents/badge/UIBadge');

var _UIBadge2 = _interopRequireDefault(_UIBadge);

var _stringUtils = require('pricing-pages-unified-ui/utils/stringUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableCell = _styledComponents2.default.td.withConfig({
  displayName: 'ProductCatalogTableCell__TableCell'
})(['height:40px;padding:10px 20px;width:18.75%;min-width:175px;text-align:center !important;p{margin:0;}line-height:14px;']);

var ProductCatalogModalTableCell = function ProductCatalogModalTableCell(_ref) {
  var merchandiseId = _ref.merchandiseId,
      featureId = _ref.featureId;

  var cellContent = null;

  var feature = _ImmutableMerchandiseIdMap2.default[merchandiseId].features[featureId];

  if (feature) {
    if (feature.shortLimitKey) {
      cellContent = _react2.default.createElement(
        _UITooltip2.default,
        {
          use: 'longform',
          title: _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'pricing-pages.fullLimits.' + feature.longLimitKey
          })
        },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _Small2.default,
            { style: { cursor: 'help' } },
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
              message: 'pricing-pages.shortLimits.' + feature.shortLimitKey
            })
          ),
          feature.isNew && (0, _stringUtils.hasStringTranslation)('pricingPage.new') && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              _UIBadge2.default,
              { use: 'new' },
              _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.new' })
            )
          )
        )
      );
    } else {
      cellContent = _react2.default.createElement(_UIIcon2.default, { name: 'success', size: 'small' });
    }
  }

  return _react2.default.createElement(
    TableCell,
    null,
    cellContent
  );
};

ProductCatalogModalTableCell.propTypes = {
  merchandiseId: _react.PropTypes.number.isRequired,
  featureId: _react.PropTypes.string.isRequired
};

exports.default = ProductCatalogModalTableCell;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-catalog/ProductCatalogTableCell.js
// module id = 686
// module chunks = 3 4